import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import Card from '../Card';

interface ModalProps {
  onClick?: (e: any) => any;
  onDismiss?: () => void;
  scrollable?: boolean;
  capHeight?: boolean;
  fixHeight?: boolean;
  flashMessage?: JSX.Element;
  height?: string;
  maxWidth?: string;
}

interface ModalContentProps {
  $fixedHeight: boolean;
}

const Overlay = styled.div`
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  display: flex;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 9999;
`;

const ModalDialog = styled(Card)<ModalProps>`
  margin: 10vh 24px 0;
  height: ${(props) => props.height || 'auto'};
  max-width: ${(props) => props.maxWidth || '600px'};
  ${(props) => (props.scrollable ? 'overflow: auto' : '')}
  ${(props) => (props.capHeight ? 'max-height: 80vh' : '')}
  ${(props) => (props.fixHeight ? ' max-height: 650px' : '')}
  width: 100%;
  z-index: 9999;

  ${(props) =>
    props.height
      ? `
        > div:last-child {
          box-sizing: border-box;
          height: 100%;
        }
      `
      : ''}
`;

const ModalContentWrapper: React.SFC<ModalContentProps> = ({ $fixedHeight: _fixedHeight, ...props }) => <div {...props} />;

const ModalContent = styled(ModalContentWrapper)<ModalContentProps>`
  height: ${(props) => (props.$fixedHeight ? '100%' : 'auto')};
`;

const handleModalClick = (e: any) => e.stopPropagation();

const Modal: React.SFC<ModalProps> = ({
  onDismiss,
  children,
  flashMessage,
  scrollable,
  capHeight,
  fixHeight = false,
  height,
  maxWidth,
}) => {
  const modalDiv = document.getElementById('modal');
  if (!modalDiv) return null;

  return ReactDOM.createPortal(
    <Overlay onClick={onDismiss}>
      <ModalDialog
        onClick={handleModalClick}
        flashMessage={flashMessage}
        scrollable={scrollable}
        capHeight={capHeight}
        fixHeight={fixHeight}
        height={height}
        maxWidth={maxWidth}
      >
        <ModalContent $fixedHeight={Boolean(height)}>{children}</ModalContent>
      </ModalDialog>
    </Overlay>,
    modalDiv,
  );
};

export default Modal;
